import type {VoidFunctionComponent} from "react";
import React, {RefObject, useEffect, useState} from "react";
import s from "./CourseLessonProgress.module.scss";
import {CourseLessonProgressMarker} from "./courseLessonProgressMarker/CourseLessonProgressMarker";
import ILessonDetail from "../../../models/view/common/ILessonDetail";

export interface ICourseLessonProgressProps {
  totalLessons: number,
  completed: number,
  incomplete: number,
  detailsOfLessons: ILessonDetail[],
  svgElement?: RefObject<SVGSVGElement>,
  courseId: number
}

export const CourseLessonProgress: VoidFunctionComponent<ICourseLessonProgressProps> = ({courseId, totalLessons, completed, incomplete, detailsOfLessons}) => {
  const [svgMarkerPadWidthPercent, setSvgMarkerPadWidthPercent] = useState<number>(0);
  const [svgMarkerDisplayWidthPercent, setSvgMarkerDisplayWidthPercent] = useState<number>(0);

  useEffect(() => {
    const displayPercentForPadding: number = 5;
    const displayPercentForDisplay: number = (100 - displayPercentForPadding);
    setSvgMarkerPadWidthPercent(displayPercentForPadding / (totalLessons - 1));
    setSvgMarkerDisplayWidthPercent(displayPercentForDisplay / totalLessons);
  }, [totalLessons]);

  return (
    <div className={s.courseLessonProgress}>
      <div className={s.courseLessonCounts}>
        <h3>{totalLessons} lessons</h3>
        {completed === totalLessons ?
          <span>All completed!</span>
          : null
        }
        {completed >= 1 && incomplete !== 0 ?
          <>
            <span className={s.lessonsCompleted}>{completed} completed</span>
            <span className={s.lessonsIncomplete}>{incomplete} incomplete</span>
          </>
          : null
        }
      </div>
      {completed !== 0 ?
        <div className={s.courseLessonMarkers}>
          <svg className={s.progressChart} viewBox={"0 0 100% 100%"} width={"100%"} height={"30px"}>
            {detailsOfLessons.map((lessonDetails, displayIndex) => {
              const {sectionId, isComplete, difficultyCategory, number} = lessonDetails;
              return <CourseLessonProgressMarker
                key={`course-${courseId}-section-${sectionId}-lesson-${number}`}
                lessonNumber={number}
                isCompleted={isComplete}
                difficultyCategory={difficultyCategory}
                displayIndex={displayIndex}
                paddingPercentWidth={svgMarkerPadWidthPercent}
                displayPercentWidth={svgMarkerDisplayWidthPercent}
              />
            })}
          </svg>
        </div>
        : null
      }
    </div>
  );
}

